<template>
    <!--
           作者：peng
           时间：2020-08-18
           描述：插件中心-客户资源
       -->
    <div>
        <!--搜索表单-->
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="状态">
                    <el-select v-model="formInline.status" placeholder="请选择客户跟进状态">
                        <el-option label="全部" value="-1"></el-option>
                        <el-option v-for="(item,index) in status" :key="index" :label="item" :value="status_type[index]"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="省市区">
                    <el-select @change="provinceChange" v-model="formInline.province_name" filterable  placeholder="请选择省份">
                        <el-option
                                v-for="item in province_options"
                                :key="item.id"
                                :label="item.name"
                                :value="item">
                        </el-option>
                    </el-select>
                    <el-select @change="cityChange" v-model="formInline.city_name" filterable placeholder="请选择城市" :disabled="lock_city">
                        <el-option
                                v-for="item in city_options"
                                :key="item.id"
                                :label="item.name"
                                :value="item">
                        </el-option>
                    </el-select>
                    <el-select @change="regionChange" v-model="formInline.region_name" filterable placeholder="请选择区域" :disabled="lock_region">
                        <el-option
                                v-for="item in region_options"
                                :key="item.id"
                                :label="item.name"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户名称"><el-input v-model="formInline.customer_name" placeholder="请输入客户名称"></el-input></el-form-item>
                <el-form-item><el-button icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
            </el-form>
        </div>

        <!-- 表格 -->
        <el-button type="primary" @click="addCustomer">添加</el-button>
        <el-button  @click="putCustomer">导入</el-button>

        <div class="table-wrap">
            <el-table :data="tableData" style="width: 100%" v-loading="loading">
                <el-table-column prop="customer_name" label="客户名称" width="220"></el-table-column>
                <el-table-column prop="customer_mobile" label="联系电话" width="220"></el-table-column>
                <el-table-column prop="customer_mobile" label="省市区">
                    <template slot-scope="scope">
                        {{scope.row.province_name}}{{scope.row.city_name}}{{scope.row.region_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="user_name" label="绑定会员" width="220"></el-table-column>
                <el-table-column prop="status" label="状态" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state == 0">未跟进</span>
                        <span v-if="scope.row.state == 1">已跟进</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="操作" width="220">
                    <template slot-scope="scope">
                        <el-button @click="editCustomer(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="delCustomer(scope.row)" type="text" size="small">删除</el-button>
                        <el-button @click="msgCustomer(scope.row)" type="text" size="small">更换绑定</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        background
                        :current-page="curPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="totalDataNumber"
                ></el-pagination>
            </div>
        </div>

        <!-- 上传导入组件  -->
        <Upload v-if="open_upload" @closeDialog="closeDialogFunc($event,'upload')"></Upload>

    </div>
</template>

<script>
    import CustomerApi from '@/api/customer.js';
    import Upload from './upload';
    export default {
        components:{
            Upload
        },
        data() {
            return {
                loading: true,
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                formInline: {},
                status_type:['0','1','2'],
                status:["未跟进","已跟进","已成交"],
                /* 城市锁 */
                lock_city:true,
                /* 区域锁 */
                lock_region:true,
                /* 表格数据 */
                tableData: [],
                province_options:{},
                city_options:{},
                region_options:{},
                open_upload:false,
            }
        },
        created() {
            this.getTableList();
            this.getAddressList();
        },
        methods: {
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },


            /* 省市区 */
            getAddressList(){
                let self = this;
                CustomerApi.provinceList('',true)
                    .then(data => {
                        console.log(data)
                        self.province_options = data.data.list;
                    })
                    .catch(error => {

                    })
            },
            /* 省 */
            provinceChange(selVal){
                let self = this
                /* 判断锁 */
                if (!self.lock_city){
                    self.formInline.city_name = ''
                    self.formInline.city_id = ''
                    self.lock_region = true
                    self.formInline.region_name = ''
                    self.formInline.region_id = ''
                }
                self.lock_city = false
                self.formInline. province_name = selVal.name
                self.formInline. province_id = selVal.id
                self.cityList(selVal.id)
            },
            /* 市列表 */
            cityList(id){
                let self = this;
                let Params = {}
                Params.province_id = id
                CustomerApi.city_list(Params,true)
                    .then(data => {
                        self.city_options = data.data.list
                    })
                    .catch(error =>{

                    });
            },
            cityChange(selVal){
                let self = this
                if (!self.lock_region){
                    self.formInline.region_name = ''
                    self.formInline.region_id = ''
                }
                self.lock_region = false
                self.formInline.city_name = selVal.name
                self.formInline.city_id = selVal.id
                self.regionList(selVal.id);
            },
            /* 区域 */
            regionList(id){
                let self = this;
                let Params = {}
                Params.region_id = id
                CustomerApi.region_list(Params,true)
                    .then(data => {
                        console.log(data)
                        self.region_options = data.data.list
                    })
                    .catch(error =>{

                    });
            },
            regionChange(selVal){
                let self = this
                self.formInline.region_name = selVal.name
                self.formInline.region_id = selVal.id
                /* 层级太深，需要手动刷新渲染 */
                self.$forceUpdate();
                console.log(self.formInline.region_name)
                console.log(self.region_options)
            },

            /* 查询 */
            onSubmit(){
                let self = this
                let Params = self.formInline;
                console.log(Params)
                self.getTableList()
            },
            /* 客户列表 */
            getTableList(){
                let self = this;
                let Params = self.formInline;
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                CustomerApi.customerList(Params,true)
                    .then(data => {
                        console.log(data)
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },
            /* 编辑客户信息 */
            editCustomer(row){
                let params = row.customer_id;
                this.$router.push({
                    path: '/plus/customer/customer/edit',
                    query: {
                        customer_id: params
                    }
                });
            },
            /* 添加客户 */
            addCustomer(){
                this.$router.push('/plus/customer/customer/add');
            },
            /* 删除客户信息 */
            delCustomer(row){
                this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    self.loading = true;
                    let params = {};
                    params.customer_id = row.customer_id;
                    CustomerApi.del_customer(params,true)
                        .then(data => {
                            self.loading = false;
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            self.getTableList();
                            return false;
                        })
                        .catch(error => {
                            self.loading = false;
                        });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                    self.loading = false;
                });
            },
            /* 绑定 */
            msgCustomer(row){
                let self = this
                this.$prompt('请输入会员ID', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^[1-9]\d*$/,
                    inputErrorMessage: '请填写正确ID'
                }).then(({value}) => {
                    let params = {};
                    params.user_id = value;
                    params.customer_id = row.customer_id;
                    CustomerApi.get_bind(params,true)
                        .then(data => {
                            self.loading = false;
                            this.$message({
                                type: 'success',
                                message: '绑定成功!'
                            });
                            self.getTableList();
                        })
                        .catch(error => {
                            console.log(error)
                            self.loading = false;
                        });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消绑定'
                    });
                })
            },
            /* 导入 */
            putCustomer(){
                this.open_upload = true
            },
            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.loading = true;
                self.getTableList();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getTableList();
            },
            /*关闭弹窗*/
            closeDialogFunc(e, f) {
                if (f == 'upload') {
                    this.open_upload = e.openDialog;
                    if (e.type == 'success') {
                          this.getTableList();
                    }
                }
            },

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/plus/customer/customer/index.vue